import { KubernetesValidatorFunctions } from '@backstage/catalog-model';

const entityNamePickerValidation = (value, validation) => {
  if (!KubernetesValidatorFunctions.isValidObjectName(value)) {
    validation.addError(
      "Must start and end with an alphanumeric character, and contain only alphanumeric characters, hyphens, underscores, and periods. Maximum length is 63 characters."
    );
  }
};

export { entityNamePickerValidation };
//# sourceMappingURL=validation.esm.js.map
